import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { courseGetAction } from 'src/reducers/course/action'
import { CourseLeftSide, CardView, EditorButtons } from './components'
import { withStyles } from '@material-ui/core'
import styles from './styles'
import { sectionDrawerOpen } from 'src/reducers/course/action'
import { CoreNavigation } from 'src/components/core'
import { useTabList } from './useTabList'
import clsx from 'clsx'
const CourseEdit = props => {
  const { classes } = props
  const dispatch = useDispatch()
  const { id, page, subPage } = useParams()
  const courseCards = useSelector(state => state.course.courseCards)
  const [sections, setSections] = useState([])

  useEffect(() => {
    dispatch(courseGetAction(id))
  }, [id])

  useEffect(() => {
    if (courseCards) {
      setSections(courseCards)
    }
  }, [courseCards])
  const open = useSelector(state => state.course.sectionDrawerOpen)

  const selectedPage = useSelector(
    state => state.courseCollectionList.selectedPageView,
  )

  const { tabList } = useTabList(selectedPage, dispatch, id, courseCards, page)

  useEffect(() => {
    const element = document.getElementById('page-view-container')

    const handleResize = () => {
      if (element) {
        if (element.offsetWidth < 1024) {
          dispatch(sectionDrawerOpen())
        }
      }
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])
  return (
    <div className={classes.content}>
      {subPage !== 'editor' && (
        <div
          className={clsx(
            page === 'page' && subPage !== 'editor'
              ? open === true
                ? classes.tabLong
                : classes.tabShort
              : classes.tab,
          )}
        >
          <CoreNavigation
            backgroundColor="primary"
            color="secondary"
            tabList={tabList}
            size="small"
          />
        </div>
      )}
      <div
        className={
          subPage === 'editor'
            ? classes.editor
            : page == 'landing-page'
            ? classes.landingPageRoot
            : classes.root
        }
      >
        {page !== 'completion' && page !== 'landing-page' && (
          <CourseLeftSide sections={sections} setSections={setSections} />
        )}
        <CardView sections={sections} setSections={setSections} />
      </div>
    </div>
  )
}

export default withStyles(styles)(CourseEdit)
